/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import moment from "moment";
import customModal from '../customModal/customModal.vue';
export default {
  name: "assignTestModal",
  components: {
    customModal,
    VPagination
  },
  props: {
    showLoading: { type: Boolean, default: false },
    labCode: { type: String, required: true },
  },
  emits: ["close", "saved"],
  data() {
    return {
      showLoading: true,
      labList: [],
      selectAll: false,
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      studyId: store.getters.getStudyIs,
      pageindex: 1,
      pagesize: 10,
      totalPage: 1,
      currentPage: 1,
      SortProperty: "TestCode",
      SortOrder: false,
      SortOrderInt: 1,
      selectedLabCode: "",
    };
  },
  async mounted() {
    this.token = store.getters.getIdToken;
    console.log("Received labCode prop:", this.labCode);
    await this.loadLabList();
  },
  watch: {
    labList: {
      deep: true,
      handler() {
        this.selectAll = this.labList.length > 0 && this.labList.every(lab => lab.selected);
      },
    },
  },
  methods: {
  async loadLabList() {
  this.showLoading = true;
  try {
    const response = await axios.get(
      `${this.baseurl}/management/labtest/labtestassignedlist?StudyId=${this.studyId}&LabCode=${this.labCode}&pageIndex=${this.pageindex}&pageSize=${this.pagesize}&sortProperty=${this.SortProperty}&sortOrder=${this.SortOrderInt}`,
      {
        
        headers: {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        },
      }
    );

    // Extract unassigned tests
    const unassignedData = response.data?.unassignedTests || {};

    this.labList = unassignedData.results || [];
    this.totalPage = Math.ceil((unassignedData.totalCount || 0) / this.pagesize);

  } catch (err) {
    console.error("Error fetching unassigned lab test list:", err);
    this.labList = [];
  } finally {
    this.showLoading = false;
  }
},


    SortSelected(sortProp) {
      if (this.SortProperty === sortProp) {
        this.SortOrder = !this.SortOrder;
      } else {
        this.SortProperty = sortProp;
        this.SortOrder = true;
      }
      this.SortOrderInt = this.SortOrder ? 0 : 1;
      this.pageindex = 1;
      this.currentPage = 1;
      this.loadLabList();
    },

    toggleSelectAll() {
      this.labList.forEach(lab => lab.selected = this.selectAll);
    },

    loadPage(page) {
      this.currentPage = page;
      this.pageindex = page;
      this.loadLabList();
    },

   async saveSelectedTests() {
  const selectedLabs = this.labList.filter(lab => lab.selected);
  if (selectedLabs.length === 0) {
    alert("Please select at least one test.");
    return;
  }

  try {
    this.showLoading = true;

    const payload = {
      studyId: this.studyId,
      labCode: this.labCode,
      assignedTests: selectedLabs.map(lab => ({
        testCode: lab.testCode,
        status: lab.status || "Active", 
      })),
      status: "Active",
    };

    const response = await axios.post(
      `${this.baseurl}/management/labtestassignment/createlabtestassignment`,
      payload,
      {
        headers: {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      this.$emit("saved", response.data);
      alert("Lab test assigned successfully");
      this.$emit("close");
    } else {
      console.error("Failed to save lab test assignment:", response);
      alert("Failed to save lab test assignment.");
    }
  } catch (err) {
    console.error("Error saving lab test assignment:", err);
    alert("An error occurred while saving lab test assignment.");
  } finally {
    this.showLoading = false;
  }
},


    closeModal() {
      this.$emit("close");
    },
   
  },
};
